import type { RawInfo } from "@/lib/raw/fastlib"

export function isSourceMonochromeRaw(info: RawInfo): boolean {
	return !info.is_cfa && info.bytes_per_pixel === 2 && info.components_per_pixel === 1
}
